import { render, staticRenderFns } from "./EditFeedbackQuestion.vue?vue&type=template&id=627e2fd5&scoped=true"
import script from "./EditFeedbackQuestion.vue?vue&type=script&lang=js"
export * from "./EditFeedbackQuestion.vue?vue&type=script&lang=js"
import style0 from "./EditFeedbackQuestion.vue?vue&type=style&index=0&id=627e2fd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627e2fd5",
  null
  
)

export default component.exports